import { ColDef } from '@ag-grid-community/core';
import { CustomColDefContext } from 'common/types/agGrid/context';
import { PIVOT_SEPARATOR } from '../Constants';

type Override<T, U> = Omit<T, keyof U> & U;

/**
 * The field of a pivoted column is a special format that joins several values together in a single string.
 * This function will check if the column uses a format like this,
 * and whether it includes the custom context object that is required to disambiguate the fieldname later.
 */
export function isColDefPivoted(
  colDef?: ColDef,
): colDef is Override<ColDef, { context: CustomColDefContext }> {
  if (!colDef) {
    return false;
  }

  const ctx: CustomColDefContext | undefined = colDef.context;
  if (!ctx || !ctx.pivotAllowed) {
    return false;
  }

  if (colDef.field?.includes(PIVOT_SEPARATOR)) {
    // field ~= 2019@@grade
    // where 2019 is one unique entry from the column we're pivoting on.
    // and grade is the value column we're aggregating on.
    return true;
  }

  if (ctx.exporting && colDef?.field?.startsWith('pivot_')) {
    // field ~= pivot_year_2019_grade
    // This path only shows up from the ExportGrid, when we're exporting a pivoted table to Excel.
    // It's the default pivot name format generated by AgGrid.
    // The custom PIVOT_SEPARATOR style is only for serverSideRowModel and the normal table.
    return true;
  }

  return false;
}
